import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { ModalPaymentFallback } from './components/modal-payment-fallback';

export const ModalPaymentError = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const modalElement = document.getElementById('modal-payment-fallback');

  if (!isMounted) return null;
  if (!modalElement) return null;

  return createPortal(<ModalPaymentFallback />, modalElement);
};
